import { render, staticRenderFns } from "./CommissionByItems.vue?vue&type=template&id=55fbe785&"
import script from "./CommissionByItems.vue?vue&type=script&lang=js&"
export * from "./CommissionByItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports